import { formatDateOnly } from "@/lib/format";

export interface DeliveryEta {
  estimatedDelivery: string | null;
  deliveryTimeZone: string | null;
  deliveryPrecision: "DATETIME" | "DATE" | null;
}

/** Show the live ETA on the accepted plan's operational calendar. */
export function formatDeliveryEta(shipment: DeliveryEta): string {
  const { estimatedDelivery, deliveryTimeZone, deliveryPrecision } = shipment;
  if (!estimatedDelivery || !deliveryTimeZone || !deliveryPrecision) return "—";
  if (deliveryPrecision === "DATE") return formatDateOnly(estimatedDelivery);

  const instant = new Date(estimatedDelivery);
  if (Number.isNaN(instant.getTime())) return "—";
  try {
    return new Intl.DateTimeFormat("en-US", {
      year: "numeric",
      month: "short",
      day: "numeric",
      timeZone: deliveryTimeZone,
    }).format(instant);
  } catch (error) {
    if (error instanceof RangeError) return "—";
    throw error;
  }
}
